/* unplugin-vue-components disabled */import script from "./ActionItemPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionItemPanel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__